// extracted by mini-css-extract-plugin
module.exports = {"authorBox":"AuthorBox_authorBox__2IxBG","authorImg":"AuthorBox_authorImg__2liVa","authorName":"AuthorBox_authorName__8Js57","authorTitle":"AuthorBox_authorTitle__1BjMq"};